import { render, staticRenderFns } from "./CreatePostModal.vue?vue&type=template&id=a6caf4a8&"
import script from "./CreatePostModal.vue?vue&type=script&lang=js&"
export * from "./CreatePostModal.vue?vue&type=script&lang=js&"
import style0 from "./CreatePostModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports